// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"hE","cusMtdicon":"hE"};